import { useCreateSubscriptionPortal } from '@/shared/api/generated/subscriptions';

export const useOpenPortal = () => {
  return useCreateSubscriptionPortal();
};
